import {EditableSetting} from "../../data/models/UpdatingSetting";
import {CurrentConfigurationData, TableColumn, TABLES_INDEXES, TABLES_NAMES} from "./types";
import * as React from "react";
import {getFormattedDate, getUnitOfMeasure, isUndefinedOrNullValue} from "../../ReadAndWrite/utils";
import {RegisterInfo} from "../../components/RegisterInfo";


export const mapSettingsToTableData = (settings: EditableSetting[]): CurrentConfigurationData[] => {

    return settings.map((setting) => {
        const currentValue = !isUndefinedOrNullValue(setting?.value)
            ? setting?.value + getUnitOfMeasure(setting?.um)
            : "-"

        return {
            info: <RegisterInfo message={setting?.notes} isVisible={setting?.notes?.length > 0}/>,
            label: setting?.label ?? "-",
            name: <p className={"font-weight-bold"}>{setting?.name ?? "-"}</p>,
            default: !isUndefinedOrNullValue(setting?.default) ? setting?.default + getUnitOfMeasure(setting?.um) : "-",
            min: setting?.min ?? "-",
            max: setting?.max ?? "-",
            lastUpdate: setting?.updatedAt ? getFormattedDate({dateToFormat: setting?.updatedAt}) : "-",
            current: <p className={"font-weight-bold"}>{currentValue}</p>,
        }
    });
}

export const createColumn = (title: string | TABLES_NAMES,
                             dataIndex: string,
                             key: string,
                             valueWidth: number,
                             isResizable: boolean = false,
                             align: "left" | "right" | "center" = "left",
): TableColumn => ({
    title: <h2 className={"settings-label"}>{title}</h2>,
    dataIndex,
    key,
    align: align,
    width: valueWidth,
    onHeaderCell: () => ({isResizable: isResizable}),
    render: (text) => <div className={"settings-value-container"}><h2 className={"settings-value"}>{text}</h2></div>,
});


export const createColumnsForCurrentSettings = (getTableHeadersName: (name: TABLES_NAMES) => string): TableColumn[] => {
    return [
        createColumn(getTableHeadersName(TABLES_NAMES.INFO), TABLES_INDEXES.INFO, TABLES_INDEXES.INFO, 20),
        createColumn(getTableHeadersName(TABLES_NAMES.LABEL), TABLES_INDEXES.LABEL, TABLES_INDEXES.LABEL, 25),
        createColumn(getTableHeadersName(TABLES_NAMES.NAME), TABLES_INDEXES.NAME, TABLES_INDEXES.NAME, 175, true),
        createColumn(getTableHeadersName(TABLES_NAMES.DEFAULT), TABLES_INDEXES.DEFAULT, TABLES_INDEXES.DEFAULT, 50),
        createColumn(getTableHeadersName(TABLES_NAMES.MIN), TABLES_INDEXES.MIN, TABLES_INDEXES.MIN, 50),
        createColumn(getTableHeadersName(TABLES_NAMES.MAX), TABLES_INDEXES.MAX, TABLES_INDEXES.MAX, 50),
        createColumn(getTableHeadersName(TABLES_NAMES.LAST_UPDATE), TABLES_INDEXES.LAST_UPDATE,
            TABLES_INDEXES.LAST_UPDATE, 100),
        createColumn(getTableHeadersName(TABLES_NAMES.CURRENT), TABLES_INDEXES.CURRENT, TABLES_INDEXES.CURRENT, 50),
    ];
}


